@mixin dropdown--size-default() {
  --font-size: var(--stzh-font-milli-font-size);
  --line-height: var(--stzh-font-milli-text-line-height);
  --letter-spacing: normal;
  --height: #{$formInputHeight};
  --border-radius: #{$formInputBorderRadius};
  --icon-size: #{iconSize("medium")};
  --icon-angle-size: #{iconSize("medium")};
  --popover-distance: #{space("xsmall")};

  --padding-top: #{space("xsmall")};
  --padding-bottom: #{space("xsmall")};
  --padding-left: #{space("medium")};
  --padding-right: #{space("medium")};

  --icon-gap: #{space("xsmall")};
  --icon-angle-gap: #{space("xsmall")};
  --remove-gap: #{space("xxsmall")};
  --remove-icon-wrapper-size: 24px;

  --multiple-padding-top: calc(#{space("xsmall")} - 1px);
  --multiple-padding-bottom: calc(#{space("xsmall")} - 1px);

  &:where([variant="plain"]) {
    --padding-left: 0px;
    --padding-right: 0px;
  }

  &:where([variant="filter"]) {
    --font-size: var(--stzh-font-micro-font-size);
    --line-height: var(--stzh-font-micro-text-line-height);
    --letter-spacing: normal;
    --border-radius: 16px;
    --height: 32px;
    --outer-height: 40px;
    --padding-top: 0px;
    --padding-bottom: 0px;
    --padding-left: #{space("small")};
    --padding-right: #{space("xsmall")};
    --icon-size: #{iconSize("xsmall")};
    --icon-angle-size: #{iconSize("xsmall")};
    --remove-gap: #{space("small")};
    --popover-distance: calc(
      #{space("xsmall")} - (var(--outer-height) - var(--height)) / 2
    );

    @include mq($from: medium) {
      --outer-height: auto;
      --popover-distance: #{space("xsmall")};
    }
  }
}

@mixin dropdown--size-large() {
  &:where([variant="filter"]) {
    --height: 40px;
    --border-radius: 20px;
    --padding-top: 0px;
    --padding-bottom: 0px;
    --padding-left: #{space("medium")};
    --padding-right: #{space("small")};
    --remove-gap: #{space("medium")};
  }
}

@mixin dropdown--size-small() {
  --font-size: var(--stzh-font-micro-font-size);
  --line-height: var(--stzh-font-micro-text-line-height);
  --letter-spacing: normal;
  --height: #{$formInputHeightSmall};
  --icon-size: #{iconSize("medium")};
  --icon-angle-size: #{iconSize("medium")};

  --padding-top: #{space("xxsmall")};
  --padding-bottom: #{space("xxsmall")};
  --padding-left: #{space("medium")};
  --padding-right: #{space("medium")};

  --icon-gap: #{space("xsmall")};
  --icon-angle-gap: #{space("xsmall")};
  --remove-gap: #{space("xxsmall")};
  --remove-icon-wrapper-size: 21px;

  --multiple-padding-top: #{space("xxsmall")};
  --multiple-padding-bottom: #{space("xxsmall")};

  &:where([variant="plain"]) {
    --padding-left: 0px;
    --padding-right: 0px;
  }

  &:where([variant="filter"]) {
    --padding-top: 0px;
    --padding-bottom: 0px;
    --padding-left: #{space("xsmall")};
    --padding-right: #{space("xsmall")};
    --remove-gap: #{space("xsmall")};
  }
}

@mixin dropdown--size-tiny() {
  --font-size: var(--stzh-font-milli-font-size);
  --line-height: var(--stzh-font-milli-text-line-height);
  --letter-spacing: normal;
  --height: #{$formInputHeightTiny};
  --icon-size: #{iconSize("medium")};
  --icon-angle-size: #{iconSize("medium")};

  --padding-top: #{space("xxsmall")};
  --padding-bottom: #{space("xxsmall")};
  --padding-left: #{space("medium")};
  --padding-right: #{space("medium")};

  --icon-gap: #{space("xsmall")};
  --icon-angle-gap: #{space("xsmall")};
  --remove-gap: #{space("xxsmall")};
  --remove-icon-wrapper-size: 21px;

  --multiple-padding-top: #{space("xxsmall")};
  --multiple-padding-bottom: #{space("xxsmall")};

  &:where([variant="plain"]) {
    --padding-left: 0px;
    --padding-right: 0px;
  }

  &:where([variant="filter"]) {
    --padding-top: 0px;
    --padding-bottom: 0px;
  }
}

stzh-dropdown {
  @include host;
  @include dropdown--size-default;

  --color: var(--stzh-dropdown-color, #{$formColor});
  --border-color: var(--stzh-dropdown-border-color, #{$formBorderColor});
  --background-color: #{$formBackgroundColor};
  --label-color: var(--stzh-dropdown-label-color, #{$formLabelColor});
  --placeholder-color: #{$formInputPlaceholderColor};
  --icon-color: #{$colorPrimary70};
  --icon-angle-color: #{$colorPrimary70};
  --label-font-size: var(--stzh-font-micro-font-size);
  --label-line-height: var(--stzh-font-micro-text-line-height);
  --label-letter-spacing: normal;

  --hover-color: var(--stzh-dropdown-hover-color, #{$formHoverColor});
  --hover-border-color: var(
    --stzh-dropdown-hover-border-color,
    #{$formHoverBorderColor}
  );
  --hover-background-color: #{$formHoverBackgroundColor};
  --hover-label-color: var(
    --stzh-dropdown-hover-label-color,
    #{$formLabelColor}
  );
  --hover-icon-color: #{$colorPrimary70};
  --hover-icon-angle-color: #{$colorPrimary70};

  --focus-color: #{$formFocusColor};
  --focus-border-color: #{$formFocusBorderColor};
  --focus-background-color: #{$formFocusBackgroundColor};
  --focus-label-color: var(
    --stzh-dropdown-focus-label-color,
    #{$formLabelColor}
  );
  --focus-icon-color: #{$colorPrimary70};
  --focus-icon-angle-color: #{$colorPrimary70};

  --active-icon-angle-transform: rotate(180deg) translateY(50%);

  --popover-width: 100%;
  --popover-min-width: initial;
  --popover-max-width: initial;
  --popover-height: auto;
  --popover-min-height: initial;
  --popover-max-height: calc(4.5 * #{$menuItemHeight});
  --popover-background-color: #{$popoverBackgroundColor};
  --popover-box-shadow: #{$boxShadowPopover};
  --popover-border-radius: #{$popoverBorderRadius};
  --popover-skidding: 0px;

  position: relative;
  width: 100%;
  border-radius: var(--border-radius);

  &:where([inline]:not([inline="false"])) {
    --popover-width: auto;
    width: auto;
  }

  /* Filled */

  &:where([is-filled]:not([is-filled="false"])) {
    --icon-color: #{$colorPrimary70};
    --icon-angle-color: #{$colorPrimary70};

    --hover-icon-color: #{$colorPrimary70};
    --hover-icon-angle-color: #{$colorPrimary70};

    --focus-icon-angle-color: #{$formFocusColor};
    --focus-icon-color: #{$formFocusColor};
  }

  &:where([variant="plain"]) {
    --background-color: transparent;

    --hover-background-color: transparent;
    --hover-label-color: #{$colorPrimary90};
    --hover-icon-color: #{$colorPrimary90};
    --hover-icon-angle-color: #{$colorPrimary90};

    --focus-background-color: transparent;
    --focus-label-color: #{$colorPrimary90};
    --focus-icon-color: #{$colorPrimary90};
    --focus-icon-angle-color: #{$colorPrimary90};
  }

  &:where([variant="plain"][is-filled]:not([is-filled="false"])) {
    --icon-color: #{$formColor};
    --icon-angle-color: #{$formColor};

    --hover-icon-color: #{$formColor};
    --hover-icon-angle-color: #{$formColor};
  }

  &:where([variant="filter"]) {
    --color: var(--stzh-chip-color, #{$colorPrimary70});
    --background-color: var(--stzh-chip-background-color, #{$colorSecondary30});
    --label-color: var(--color);
    --icon-color: var(--color);
    --icon-angle-color: var(--color);

    --hover-color: var(--stzh-chip-hover-color, #{$colorPrimary70});
    --hover-background-color: var(
      --stzh-chip-hover-background-color,
      #{$colorSecondary40}
    );
    --hover-label-color: var(--hover-color);
    --hover-icon-color: var(--hover-color);
    --hover-icon-angle-color: var(--hover-color);

    --focus-color: var(--hover-color);
    --focus-background-color: var(--hover-background-color);
    --focus-label-color: var(--hover-label-color);
    --focus-icon-color: var(--hover-icon-color);
    --focus-icon-angle-color: var(--hover-icon-angle-color);
  }

  &:where([variant="filter"][is-filled]:not([is-filled="false"])) {
    --color: var(--stzh-chip-active-color, #{$colorWhite});
    --background-color: var(
      --stzh-chip-active-background-color,
      #{$colorPrimary70}
    );

    --hover-color: var(--stzh-chip-active-hover-color, #{$colorWhite});
    --hover-background-color: var(
      --stzh-chip-active-hover-background-color,
      #{$colorPrimary90}
    );
  }

  /* Invalid */

  &[is-invalid] {
    --color: #{$colorError60};
    --border-color: #{$colorError60};
    --background-color: #{$colorWhite};
    --label-color: #{$colorError60};
    --placeholder-color: #{$colorError60};
    --icon-color: #{$colorError60};
    --icon-angle-color: #{$colorError60};

    --hover-color: #{$colorError60};
    --hover-border-color: #{$colorError60};
    --hover-background-color: #{$colorWhite};
    --hover-label-color: #{$colorError60};
    --hover-icon-color: #{$colorError60};
    --hover-icon-angle-color: #{$colorError60};

    --focus-color: #{$colorError60};
    --focus-border-color: #{$colorError60};
    --focus-background-color: #{$colorWhite};
    --focus-label-color: #{$colorError60};
    --focus-icon-color: #{$colorError60};
    --focus-icon-angle-color: #{$colorError60};
  }

  /* Disabled */

  &[disabled]:not([disabled="false"]) {
    --color: #{$formDisabledColor};
    --border-color: #{$formDisabledBorderColor};
    --background-color: #{$formDisabledBackgroundColor};
    --label-color: #{$formDisabledColor};
    --placeholder-color: #{$formDisabledColor};
    --description-color: #{$formDisabledColor};
    --icon-color: #{$colorGrey70};
    --icon-angle-color: #{$colorGrey70};

    --hover-color: #{$colorGrey70};
    --hover-border-color: #{$colorGrey70};
    --hover-background-color: #{$colorGrey10};
    --hover-label-color: #{$colorGrey70};
    --hover-icon-color: #{$colorGrey70};
    --hover-icon-angle-color: #{$colorGrey70};

    --focus-color: var(--color);
    --focus-border-color: var(--border-color);
    --focus-background-color: var(--background-color);
    --focus-label-color: var(--label-color);
    --focus-icon-color: var(--icon-color);
    --focus-icon-angle-color: var(--icon-angle-color);
  }

  &[disabled]:not([disabled="false"])[variant="plain"] {
    --background-color: transparent;
  }

  &[disabled]:not([disabled="false"])[variant="filter"] {
    --color: var(--stzh-chip-disabled-color, #{$colorGrey80});
    --background-color: var(
      --stzh-chip-disabled-background-color,
      #{$colorGrey20}
    );
    --label-color: var(--color);
    --placeholder-color: var(--color);
    --icon-color: var(--color);
    --icon-angle-color: var(--color);
    --description-color: #{$formDisabledColor};
  }

  /* Internal (Hover / Focus) */

  &:is(:has(.stzh-dropdown__label:hover)),
  &:is(:has(.ts-control:hover)) {
    --color: var(--hover-color);
    --border-color: var(--hover-border-color);
    --background-color: var(--hover-background-color);
    --label-color: var(--hover-label-color);
    --icon-color: var(--hover-icon-color);
    --icon-angle-color: var(--hover-icon-angle-color);
  }

  &:is(:has(.ts-control:focus-within)) {
    --color: var(--focus-color);
    --border-color: var(--focus-border-color);
    --background-color: var(--focus-background-color);
    --label-color: var(--focus-label-color);
    --icon-color: var(--focus-icon-color);
    --icon-angle-color: var(--focus-icon-angle-color);
  }
}

stzh-dropdown:where([size="large"]) {
  @include dropdown--size-large;
}

stzh-dropdown:where([size="small"]) {
  @include dropdown--size-small;
}

stzh-dropdown:where([size="tiny"]) {
  @include dropdown--size-tiny;
}

@each $breakpoint, $size in $breakpoints {
  @include mq($from: $breakpoint) {
    stzh-dropdown:where([size-#{$breakpoint}="default"]) {
      @include dropdown--size-default;
    }

    stzh-dropdown:where([size-#{$breakpoint}="large"]) {
      @include dropdown--size-large;
    }

    stzh-dropdown:where([size-#{$breakpoint}="small"]) {
      @include dropdown--size-small;
    }

    stzh-dropdown:where([size-#{$breakpoint}="tiny"]) {
      @include dropdown--size-tiny;
    }
  }
}

.stzh-dropdown {
  @include input-description;

  &__wrapper {
    position: relative;
  }

  .ts-hidden-accessible {
    @include visuallyhidden;
  }

  .ts-dropdown-content {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    overflow-scrolling: touch;
    // scroll-behavior: smooth;
  }

  .ts-wrapper {
    display: flex;
    align-items: center;
    min-height: var(--outer-height);
  }

  .ts-control {
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    min-height: var(--height);
    border-radius: var(--border-radius);
    background-color: var(--background-color);
    transition-property: border-color, background-color;
    transition-duration: $baseTransitionAnimationSpeed;
    cursor: pointer;

    & > * {
      vertical-align: baseline;
      display: inline-block;
    }
  }

  .ts-control,
  .ts-control > input,
  &__sizer {
    @include fontSize("milli");
    @include font("medium");
    font-size: var(--font-size);
    line-height: var(--remove-icon-wrapper-size);
    letter-spacing: var(--letter-spacing);
    width: 100%;
    border: 2px solid var(--border-color);
  }

  .ts-control > input {
    flex: 1 1 auto;
    display: inline-block;
    padding: 0;
    min-height: 0;
    max-height: none;
    max-width: 100%;
    margin: space("xxsmall") space("xxsmall") space("xxsmall") 0;
    text-indent: 0;
    border: 0 none;
    background: none;
    user-select: auto;
    box-shadow: none;
    cursor: pointer;

    @include placeholder {
      color: var(--placeholder-color);
    }

    &::-ms-clear {
      display: none;
    }

    &:focus {
      outline: none;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
  }

  &__vhidden {
    @include visuallyhidden;
  }

  &__field-wrapper,
  &__select {
    position: relative;
  }

  &__select .ts-control > input,
  &__select.single &__item,
  &__icon-wrapper,
  &__icon-angle-wrapper {
    transition: color $baseTransitionAnimationSpeed;
  }

  &__select .ts-control > input,
  &__select.single &__item {
    color: var(--color);
  }

  &__sizer {
    height: var(--height);
    display: flex;
    align-items: center;
    margin-top: calc(var(--height) / -1);
    pointer-events: none;
    visibility: hidden;
  }

  &__select.has-items ~ &__sizer {
    display: none;
  }

  &__select.plugin-input_hide ~ &__sizer {
    visibility: visible;
  }

  &__select.input-active .ts-control,
  &__select.input-active .ts-control > input {
    cursor: text;
  }

  &__select.input-hidden .ts-control > input,
  &__select.plugin-input_hide .ts-control > input {
    // hide input, while retaining its focus, and maintain layout so users can still click on the space to bring the display back
    // visibility:hidden can prevent the input from receiving focus
    opacity: 0;
    position: absolute;
    left: -10000px;
  }

  &__select.single .ts-control,
  &__select.multi .ts-control,
  &__sizer {
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);
    padding-left: var(--padding-left);
    padding-right: calc(
      var(--icon-angle-size) + var(--icon-angle-gap) + var(--padding-right)
    );
  }

  &__icon-wrapper,
  &__icon-angle-wrapper {
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    // transition-property: color, transform;
    // transition-duration: $baseTransitionAnimationSpeed;
  }

  &__icon-wrapper {
    left: var(--padding-left);
    color: var(--icon-color);
  }

  &__icon-angle-wrapper {
    right: var(--padding-right);
    color: var(--icon-angle-color);
  }

  &__icon-wrapper stzh-icon,
  &__icon {
    --size: var(--icon-size);
  }

  &__icon-angle-wrapper stzh-icon,
  &__icon-angle {
    --size: var(--icon-angle-size);
  }

  &__label {
    @include font("heavy");
    @include truncate;
    font-size: var(--label-font-size);
    line-height: var(--label-line-height);
    letter-spacing: var(--label-letter-spacing);
    color: var(--label-color);
    display: block;
    width: auto;
    max-width: 100%;
    margin-bottom: space("xxxsmall");

    &.no-label-truncate {
      @include resetTruncate;
    }

    &:empty {
      display: none;
    }

    // &::before {
    //   content: '';
    //   display: none;
    //   background: var(--label-background); // --label-background removed
    //   position: absolute;
    //   width: 100%;
    //   z-index: -1;
    //   left: 0;
    //   top: 50%;
    //   // prevent white line not fully overlaping border of input
    //   height: 2px;
    //   margin-top: -0.5px;
    // }
  }

  &__marker {
    @include fontSize("nano");
    margin-left: calc(-0.25em + #{space("xsmall")});
  }

  &__option,
  &__create,
  &__no-results,
  &__not-loading {
    @include fontSize("micro");
    padding: space("xsmall") space("medium");
    padding-right: space("large");
  }

  &__option,
  &__create {
    display: flex;
    align-items: center;
    justify-content: stretch;
    appearance: none;
    font-family: inherit;
    text-decoration-line: none;
    outline: none;
    border: none;
    color: $colorBlack;
    min-height: $menuItemHeight;
    transition: all $baseTransitionAnimationSpeed;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: $colorGrey20;
    }

    // hide checkbox visually
    input {
      @include visuallyhidden;
    }
  }

  &__option {
    &.selected {
      color: $colorPrimary70;

      // announce check when item is selected
      &::before {
        @include visuallyhidden;
        content: "✓";
      }
    }

    &[aria-disabled="true"] {
      cursor: not-allowed;
      color: #{$colorGrey70};
      background-color: #{$colorGrey10};
    }
  }

  &__create {
    display: block;
  }

  &__option-title {
    // @include truncate;
    flex-grow: 1;
  }

  &__option[data-selectable] .highlight {
    @include font("heavy");
  }

  &__option-check {
    display: none;
  }

  &__no-results {
    @include wordWrap;
  }

  &__optgroup {
  }

  &__optgroup-header {
    cursor: default;
  }

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: $menuItemHeight;
  }

  &__dropdown {
    position: absolute;
    // top: 100%;
    // left: 0;
    top: auto;
    left: auto;
    white-space: nowrap;
    margin-top: var(--popover-distance);
    margin-left: var(--popover-skidding);
    transform: none;
    z-index: $zIndexPopover;
    width: var(--popover-width);
    min-width: var(--popover-min-width);
    max-width: var(--popover-max-width);
    height: var(--popover-height);
    min-height: var(--popover-min-height);
    max-height: var(--popover-max-height);
    background-color: var(--popover-background-color);
    box-shadow: var(--popover-box-shadow);
    border-radius: var(--popover-border-radius);
  }

  &__remove-icon {
    --size: #{iconSize("xxsmall")};
  }

  /* Plugin: Input autogrow */

  &__select.plugin-input_autogrow.has-items .ts-control > input {
    min-width: 0;
  }

  &__select.plugin-input_autogrow.has-items.focus .ts-control > input {
    flex: none;
    min-width: 4px;
  }

  /* Has Items */

  &__select.has-items .ts-control > input {
    margin: 0 4px;
    @include placeholder {
      color: transparent;
    }
  }

  /* Is Open */

  &__select.dropdown-active ~ &__icon-angle-wrapper {
    transform: var(--active-icon-angle-transform);
  }

  /* Multiple variant */

  &--is-multiple &__option-check {
    display: inline-flex;
    opacity: 0;
    transition: opacity $baseTransitionAnimationSpeed;
    margin-left: space("xsmall");
  }

  // &--is-multiple &__option,
  // &--is-multiple &__create {
  //   &.selected {
  //     color: $colorPrimary70;
  //   }

  //   // &.selected:hover,
  //   // &.selected.active {
  //   //   color: $colorPrimaryHover;
  //   //   background-color: $colorPrimary20;
  //   // }
  // }

  &--is-multiple &__option.selected &__option-check {
    opacity: 1;
  }

  &--is-multiple &__select.multi.has-items .ts-control {
    padding-top: var(--multiple-padding-top);
    padding-bottom: var(--multiple-padding-bottom);
  }

  &--is-multiple &__select.multi &__item {
    @include fontSize("micro");
    position: relative;
    min-height: var(--remove-icon-wrapper-size);
    height: fit-content;
    line-height: var(--remove-icon-wrapper-size);
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 12px;
    padding: 0 space("small");
    appearance: none;
    font-family: inherit;
    color: $colorPrimary70;
    background-color: $colorPrimary10;
    transition: all $baseTransitionAnimationSpeed;
    margin: space("xxsmall") space("xxsmall") space("xxsmall") 0;
    cursor: pointer;

    &:hover {
      color: $colorPrimary90;
      background-color: $colorPrimary20;
    }

    &.active {
      color: $colorWhite;
      background-color: $colorPrimary70;
    }
  }

  /* Plugin: Remove button */

  &__select.plugin-remove_button &__item,
  &--is-multiple &__select.plugin-remove_button &__item {
    display: inline-flex;
    align-items: center;
    gap: var(--remove-gap);
    padding-right: 0px;
  }

  &__select.plugin-remove_button &__item .remove {
    position: relative;
    right: -1px; // -1px to overlap border
    text-decoration-line: none;
    width: var(--remove-icon-wrapper-size);
    height: var(--remove-icon-wrapper-size);
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $colorPrimary70;
    flex-shrink: 0;
    transition: all $baseTransitionAnimationSpeed;

    &:hover {
      color: $colorPrimary90;
      background-color: $colorPrimary30;
    }
  }

  &--is-multiple &__select.plugin-remove_button &__item.active &__remove-icon {
    color: $colorWhite;
  }

  /* Popover placement */

  &--popover-placement-top &__dropdown,
  &--popover-placement-top-end &__dropdown,
  &--popover-placement-top-center &__dropdown {
    margin-top: 0;
    top: auto;
    bottom: 100%;
    margin-bottom: calc(
      var(--popover-distance) - 19.5px
    ); // distance - label height
  }

  &--popover-placement-top#{&}--plain &__dropdown,
  &--popover-placement-top-end#{&}--plain &__dropdown,
  &--popover-placement-top-center#{&}--plain &__dropdown {
    margin-bottom: 0;
  }

  &--popover-placement-top-end &__dropdown,
  &--popover-placement-bottom-end &__dropdown {
    left: auto;
    right: 0;
  }

  &--popover-placement-top-center &__dropdown,
  &--popover-placement-bottom-center &__dropdown {
    left: 50%;
    transform: translateX(-50%);
  }

  /* Has fullwidth popover */

  &--popover-fullwidth-horizontal &__dropdown {
    left: 0;
    right: 0;
    transform: none;
  }

  /* Hidden label */

  &--has-label-hidden &__label {
    @include visuallyhidden;
  }

  /* Override for popover placement top and hidden label */

  &--has-label-hidden#{&}--popover-placement-top &__dropdown,
  &--has-label-hidden#{&}--popover-placement-top-end &__dropdown,
  &--has-label-hidden#{&}--popover-placement-top-center &__dropdown {
    margin-bottom: calc(
      var(--popover-distance) - 1px
    ); // distance - visuallyhidden height
  }

  /* Has icon */

  &--has-icon &__select.single .ts-control,
  &--has-icon &__select.multi .ts-control,
  &--has-icon &__sizer {
    padding-left: calc(
      var(--padding-left) + var(--icon-size) + var(--icon-gap)
    );
  }

  /* Plain */

  &--plain &__select.single .ts-control,
  &--plain &__select.multi .ts-control,
  &--plain &__sizer {
    border: none;
  }

  &--plain &__label {
    left: 0;
    max-width: 100%;
    padding: 0;

    z-index: 1;
    position: absolute;
    margin: 0;
    // top: calc(var(--height) / 2);
    top: 50%;
    // padding-left (medium) + border-left
    // left: calc(#{space('medium')} + 1px);
    // max-width: calc(100% - #{space('medium')} * 2);
    transform: translateY(-50%);
    transition: all $baseTransitionAnimationSpeed;
    pointer-events: none;

    &::before {
      content: none;
    }
  }

  &--plain &__dropdown {
    margin-top: 0;
  }

  &--plain#{&}--has-icon &__label {
    left: calc(var(--icon-size) + var(--icon-gap));
  }

  /* Styles for floating label */

  // &--is-filled &__label,
  // &--is-disabled &__label,
  // &--is-invalid &__label,
  // &--has-focus &__label {
  //   top: 0;
  //   // padding-left (input field medium) - padding-left
  //   left: calc(#{space('medium')} - #{space('xxsmall')});
  //   height: 20px; // dividable by two (so before element is always positioned correctly)
  //   line-height: 20px;
  //   padding: 0 space('xxsmall');
  //   max-width: calc(100% - (#{space('medium')} - #{space('xxsmall')}) * 2);
  //   pointer-events: all;

  //   &:not(:empty)::before {
  //     display: block;
  //   }
  // }

  &--plain#{&}--has-focus:not(#{&}--has-no-search) &__label,
  &--plain#{&}--is-filled &__label {
    @include visuallyhidden;
  }

  &--plain#{&}--is-filled &__label,
  &--plain#{&}--is-disabled &__label,
  &--plain#{&}--is-invalid &__label,
  &--plain#{&}--has-focus &__label {
    // left: 0;
    // padding: 0;
    // max-width: 100%;

    // top: 0;
    // height: 20px; // dividable by two (so before element is always positioned correctly)
    // line-height: 20px;
    // pointer-events: all;

    // &:not(:empty)::before {
    //   display: block;
    // }
  }

  /* Has no search */

  &--has-no-search .ts-control > input {
    position: absolute;
    width: 0px;
    height: 0px;
  }

  &--has-no-search &__select.input-active .ts-control,
  &--has-no-search &__select.input-active .ts-control > input {
    cursor: pointer;
  }

  /* Filter */

  &--filter &__option,
  &--plain &__option {
    background-color: $colorSecondary10;
    color: $colorPrimary70;

    &:hover,
    &.active {
      background-color: $colorSecondary20;
    }
  }

  &--filter &__select.single .ts-control,
  &--filter &__select.multi .ts-control,
  &--filter &__sizer {
    border: none;
  }

  &--filter &__label {
    @include font;
    left: var(--padding-left);
    max-width: 100%;
    padding: 0;

    z-index: 1;
    position: absolute;
    margin: 0;
    // top: calc(var(--outer-height) / 2);
    top: 50%;
    // padding-left (medium) + border-left
    // left: calc(#{space('medium')} + 1px);
    // max-width: calc(100% - #{space('medium')} * 2);
    transform: translateY(-50%);
    transition: all $baseTransitionAnimationSpeed;
    pointer-events: none;

    &::before {
      content: none;
    }
  }

  &--filter#{&}--has-icon &__label {
    left: calc(var(--padding-left) + var(--icon-size) + var(--icon-gap));
  }

  &--filter#{&}--has-focus:not(#{&}--has-no-search) &__label,
  &--filter#{&}--is-filled &__label {
    @include visuallyhidden;
  }

  &--filter &__select.plugin-remove_button &__item .remove {
    color: $colorPrimary70;
    background-color: $colorSecondary30;
    width: var(--height);
    height: var(--height);
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;

    &:hover {
      color: $colorBlack;
      background-color: $colorSecondary40;
    }
  }

  &--filter &__remove-icon {
    --size: #{iconSize("xsmall")};
  }

  &--filter#{&}--is-filled &__icon-angle-wrapper {
    display: none;
  }

  &--filter#{&}--is-filled &__select.single .ts-control,
  &--filter#{&}--is-filled &__select.multi .ts-control,
  &--filter#{&}--is-filled &__sizer {
    padding-right: 0px;
  }

  /* Disabled */

  &--is-disabled &__select.multi &__item,
  &--is-disabled &__select.plugin-remove_button &__item .remove {
    cursor: not-allowed;
  }

  &--is-disabled &__select.multi &__item,
  &--is-disabled &__select.multi &__item:hover {
    color: $colorGrey70;
    background-color: $colorWhite;
  }

  &--is-disabled &__select.plugin-remove_button &__item .remove,
  &--is-disabled &__select.plugin-remove_button &__item .remove:hover {
    color: $colorGrey70;
    background-color: transparent;
  }

  &--is-disabled &__label,
  &--is-disabled .ts-control,
  &--is-disabled .ts-control > input {
    cursor: not-allowed;
  }

  /* No text wrap */
  &--is-inline#{&}--has-no-wrap {
    white-space: nowrap;
  }
}
